import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
    borderBottom: '1px solid #C6C6C6',
    boxSizing: 'border-box',
    paddingBottom: '5px'
  },

  label: {
    marginRight: '8px',
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#3C425B'
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& > :not(:last-child)': {
      marginRight: '4px'
    }
  },

  dropdown: {
    cursor: 'default !important',

    '& .clickable': {
      marginLeft: '4px',
      cursor: 'pointer'
    }
  },

  button: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '6px 12px',
    background: 'white',
    cursor: 'pointer',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  channel: {
    display: 'flex',
    alignItems: 'center',

    '& > :last-child': {
      marginLeft: '4px'
    }
  },

  paper: {
    width: 'unset'
  },

  item: {
    paddingRight: '16px'
  }
}))

export default useStyles
